import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { useGetCustomerQuery } from '@/api/v1';
import { RouteSuspenseFallback } from '@/components/molecules/RouteSuspenseFallback';
import { useLogout } from '@/hooks/useLogout';
import { lazyRoute } from '@/utility/lazyRoute';

const Dashboard = lazyRoute(
  (): Promise<typeof import('@/Screens/Dashboard')> => import('@/Screens/Dashboard'),
  'Dashboard',
);

const PrivateRoutes: React.FC = (): React.ReactElement => {
  const { isError } = useGetCustomerQuery();
  const logout = useLogout();

  if (isError) {
    logout();

    return <></>;
  }

  return (
    <Routes>
      <Route
        path="/*"
        element={
          <React.Suspense fallback={<RouteSuspenseFallback />}>
            <Dashboard />
          </React.Suspense>
        }
      />
      <Route path="/logout" element={<Navigate to="/" replace={true} />} />

      <Route path="*" element={<Navigate to="/dashboard" replace={true} />} />
    </Routes>
  );
};

export default PrivateRoutes;
